.cosProgress {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
